export const SELECTORS = {
  HEADER_PROMO: '#shopify-section-announcement-bar',
};

export const reflow = () => {
  void(document.documentElement.offsetTop);
};

export const disableButton = (button) => {
  button.disabled = true;
  button.classList.add('button--disabled');
};

export const enableButton = (button) => {
  button.disabled = false;
  button.classList.remove('button--disabled');
};

export const hideButton = (button) => {
  button.disabled = true;
  button.classList.add('button--hidden');
};

export const showButton = (button) => {
  button.disabled = false;
  button.classList.remove('button--hidden');
};

export const getPromoBarHeight = () => {
  const headerPromo = document.querySelector(`${SELECTORS.HEADER_PROMO}`);

  if (headerPromo && headerPromo.offsetTop === 0) {
    return headerPromo.clientHeight;
  }

  return 0;
};

